import {ReviewsSection_ReviewSummary} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {
  useTrackFeature,
  useTrackFeatureInViewImpression,
} from '@aboutyou/tracking';

export const useUserReviewsTracking = (
  summary?: ReviewsSection_ReviewSummary,
) => {
  const trackFeatureLabel = `review|adp|${summary?.overallRating}|${summary?.reviewCount}`;
  const {ref: trackFeatureImpressionRef} = useTrackFeatureInViewImpression(
    {
      label: trackFeatureLabel,
    },
    {threshold: 0.1},
  );
  const trackFeature = useTrackFeature();
  const handleAllReviewsButtonFeatureClick = () => {
    trackFeature({eventType: 'click', label: trackFeatureLabel});
  };

  return {trackFeatureImpressionRef, handleAllReviewsButtonFeatureClick};
};
